import React from 'react'
import './styles.css'

export default function Marker() {
  return (
    <div className="marker"></div>
  )
}
